/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, styled, Box,
  Typography,
  useTheme,
} from '@material-ui/core';
import { AlertIcon } from '../../../assets/img/marketPlace/AlertIcon';

const DialogFilter = ({ maxWidthValue, maxHeightValue, ...otherProps }) => (
  <Dialog {...otherProps} />
);

const DialogFilterTitle = ({ textSizeTitle, ...otherProps }) => (
  <DialogTitle {...otherProps} />
);

const OwnDialog = styled(DialogFilter)(({ maxWidthValue }) => ({
  '& .MuiPaper-root': {
    padding: '16px',
    borderRadius: '12px',
    minWidth: '350px',
    maxWidth: maxWidthValue || '500px',
    width: '100%',
  },
}));

const OwnDialogTitle = styled(DialogFilterTitle)(({ theme, textSizeTitle }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  paddingBottom: 0,
  color: theme.header.badgeItems.color,
  '& .MuiTypography-h6': {
    fontSize: textSizeTitle || 24,
    fontWeight: 700,
    whiteSpace: 'pre-line',
    letterSpacing: 0,
    fontFamily: '"Karla"',
  },
  /* color: theme.header.badgeItems.color, */
}));

const OwnDialogContent = styled(DialogContent)(() => ({
  padding: '8px 24px 16px',
  maxHeight: '70vh',
  overflowY: 'auto',
}));

const OwnDialogActions = styled(DialogActions)(() => ({
  justifyContent: 'center',
  gap: '12px',
  padding: '0px 24px 24px 24px',
  fontFamily: '"Karla"',
}));

const AcceptButton = styled(Button)(({ theme, weight }) => ({
  textTransform: 'none',
  fontWeight: weight || 600,
  padding: '10px 32px',
  borderRadius: '8px',
  color: theme.body.cart.products.main,
  width: '100%',
  '& .MuiButton-label': {
    fontWeight: 'inherit',
  },
}));

const CancelButton = styled(Button)(({ weight }) => ({
  textTransform: 'none',
  fontWeight: weight || 600,
  padding: '10px 32px',
  borderRadius: '8px',
  width: '100%',
  '& .MuiButton-label': {
    fontWeight: 'inherit',
  },
}));

const OwnTypography = styled(Typography)(() => ({
  fontSize: 20,
  fontWeight: 700,
  color: 'black',
}));

const CustomDialog = (props) => {
  const {
    textTitle,
    subTitile,
    textContent,
    textCloseDialog,
    isOpen,
    setIsOpen,
    textAccept,
    acceptAction,
    children,
    showIcon = false,
    alignLeft = false,
    maxWidthValue,
    acceptButtonStyle = {},
    cancelButtonStyle = {},
    showChildren = true,
    showSpaceDown = false,
    textSizeTitle,
    typographyProps = {},
    acceptButtonWeight,
    cancelButtonWeight,
  } = props;

  const theme = useTheme();

  return (
    <OwnDialog open={Boolean(isOpen)} maxWidthValue={maxWidthValue} disableRestoreFocus>
      <OwnDialogTitle style={{ alignItems: alignLeft ? 'flex-start' : 'center', textAlign: alignLeft ? 'left' : 'center' }} textSizeTitle={textSizeTitle}>
        {showIcon && (
          <Box mb={1}>
            <AlertIcon color={theme.body.dialog.colorIcon} />
          </Box>
        )}
        {textTitle}
        {subTitile && (
          <OwnTypography>
            {subTitile}
          </OwnTypography>
        )}
      </OwnDialogTitle>
      {
        showSpaceDown && (
          <br />
        )
      }
      {
        showChildren && (
        <OwnDialogContent style={{ textAlign: alignLeft ? 'left' : 'center' }}>
          {textContent && (
          <Box mb={2}>
            <OwnTypography style={{ ...typographyProps }}>
              {textContent}
            </OwnTypography>
          </Box>
          )}
          {children}
        </OwnDialogContent>
        )
      }
      <OwnDialogActions>
        <CancelButton
          onClick={() => setIsOpen(false)}
          style={cancelButtonStyle}
          weight={cancelButtonWeight}
        >
          {textCloseDialog}
        </CancelButton>
        <AcceptButton
          onClick={acceptAction}
          style={acceptButtonStyle}
          weight={acceptButtonWeight}
        >
          {textAccept}
        </AcceptButton>
      </OwnDialogActions>
    </OwnDialog>
  );
};

export default CustomDialog;
